import * as React from 'react';
import { useFeatureServices } from './use-feature-services';
import { Header } from './components/header/header';
import { TimelineGti } from './components/timelineGti/timelineGti';
import { GlobalStyle } from './styles/GlobalStyle';
import { GalleryGti50 } from './components/galleyGti50/galleryGti50';
import GTI50Reveal from './components/gti50Reveal/gti50Reveal';
import LimitedUnits from './components/limitedUnits/limitedUnits';
import { EndModuleGti50 } from './components/endModuleGti50/endModuleGti50';
import { DetailGti50 } from './components/deteailGti50/detailGti50';
import { FormGti50 } from './components/formGti50/formGti50';
import { NbabGti50 } from './components/nbabGti50/nbabGti50';

export interface FaContentGTI {
  active_gti_form: string;
}

export function Home(): JSX.Element {
  const {
    'breadcrumb-service': breacrumbService,
    'page-info-service': pageInfoService,
    'fa-content-service': contentService,
  } = useFeatureServices();

  const faContentGTI = contentService?.content as FaContentGTI;

  React.useEffect(() => {
    breacrumbService.set([]);
    pageInfoService.setPageInfo();
  }, [pageInfoService, breacrumbService]);

  return (
    <>
      <GlobalStyle />
      {faContentGTI.active_gti_form == 'true' && <NbabGti50 />}
      <Header />
      <TimelineGti />
      <GTI50Reveal />
      <LimitedUnits />
      {faContentGTI.active_gti_form == 'true' && <FormGti50 />}
      <DetailGti50 />
      <GalleryGti50 />
      <EndModuleGti50 />
    </>
  );
}
